import React from 'react';
import { GlobeIcon } from 'lucide-react';
import { CountdownTimer } from '../CountdownTimer';
import { CtaButton } from '../CtaButton';
import { ScarcityBar } from '../ScarcityBar';
import { PRODUCT_IMAGE } from '../../data/content';
const summary = ['6 Volumes', '300+ Protocols', 'Decision Algorithms', '30+ Cases', '5 Practical Bonuses'];
export function FinalCta() {
  return <section className="bg-ink-900 px-5 py-14 sm:px-8 sm:py-20" data-id="element-130" data-mp="1ens27i6ul7qv">
      <div className="mx-auto max-w-2xl" data-id="element-131" data-mp="1eqe5h5mph13a">
        <h2 className="text-center font-display text-[28px] font-bold uppercase leading-[1.05] tracking-tight text-white sm:text-4xl" data-id="element-132" data-mp="1iq560121avl0">
          Stop searching. <span className="text-teal-300" data-id="element-133" data-mp="14s89t5rhsr6v">Start using a system.</span>
        </h2>

        <p className="mt-5 text-center text-[15px] leading-relaxed text-white/70 sm:text-base" data-id="element-134" data-mp="19pqg0oe4ksb6">
          You can continue opening multiple guidelines every time a TRT question comes up. Or you
          can organize the process around one practical clinical system.
        </p>

        <img src={PRODUCT_IMAGE} alt="Master System of TRT complete digital system" className="mx-auto mt-8 w-full max-w-sm drop-shadow-[0_25px_45px_rgba(0,0,0,0.55)]" width={1080} height={1080} data-id="element-135" data-mp="27tt21jyozyy" />

        <ul className="mt-8 grid grid-cols-2 gap-2" data-id="element-136" data-mp="6ztl77tsiokz">
          {summary.map((item, i) => <li key={item} className={`rounded-xl border border-teal-400/20 bg-ink-800/70 px-3 py-3 text-center font-display text-sm font-bold uppercase tracking-[0.08em] text-teal-200 sm:text-base ${i === summary.length - 1 ? 'col-span-2' : ''}`} data-id="element-137" data-mp="3ffn4tvjf4g69" data-mpi={i}>
              {item}
            </li>)}
        </ul>

        <p className="mt-6 text-center font-display text-2xl font-bold uppercase tracking-[0.06em] text-white sm:text-3xl" data-id="element-138" data-mp="3jjcn639i21iu">
          All for $27
        </p>

        <div className="mt-6 space-y-3" data-id="element-139" data-mp="ypzkn7q18njc">
          <CtaButton label="Get the Master System of TRT™" subLabel="One-Time Payment · Instant Access · Lifetime Access · 7-Day Guarantee" data-id="element-140" data-mp="ytdko9b84knm" />
          <CountdownTimer label="Promotional price resets in" data-id="element-141" data-mp="1b4vipcbq11d" />
          <ScarcityBar spotsLeft={12} total={150} data-id="element-142" data-mp="5e1fajdlo36w" />
          <p className="flex items-start justify-center gap-2 text-center text-[12px] leading-snug text-white/60" data-id="element-143" data-mp="5c6rmxay1wz4">
            <GlobeIcon className="mt-0.5 h-4 w-4 shrink-0 text-teal-300" aria-hidden="true" data-id="element-144" data-mp="39shriskhljj5" />
            Currency is converted automatically to your local currency at checkout.
          </p>
        </div>

        <div className="mt-12 rounded-2xl border border-white/10 bg-ink-800/60 p-6 text-center sm:p-8" data-id="element-145" data-mp="3it62feel33rt">
          <p className="font-display text-xl font-bold uppercase leading-tight tracking-tight text-white sm:text-2xl" data-id="element-146" data-mp="3njmk5apftbjz">
            Your next TRT consultation doesn’t have to start with a Google search.
          </p>
          <p className="mt-3 text-sm text-white/70 sm:text-base" data-id="element-147" data-mp="2v2tp1o0kketu">
            Build your own structured TRT reference today.
          </p>
          <div className="mx-auto mt-6 max-w-md" data-id="element-148" data-mp="2njaymwozxjb8">
            <CtaButton label="Get the Master System for $27" subLabel="Access the complete digital system now" data-id="element-149" data-mp="2ikhlx6hj9wc4" />
          </div>
        </div>
      </div>
    </section>;
}